import {
  AfterViewInit,
  ChangeDetectionStrategy, Component, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild
} from '@angular/core';
import {Tools} from "linkurious-shared";
import {MenuComponent} from "../component";

@Component({
  selector: 'menu-item',
  template: `<button #button
        (click)="trigger($event)"
        class="menu_action"
        [class.active]="active"
        [class.has_subMenu]="subMenu"
        [class.disabled]="disabled"
        [class.menu_action--icon]="withIcon"
        [class.menu_action--bordered]="withBorder === '' || withBorder === true">
  <icon *ngIf="withIcon" [name]="iconName" [stroke]="stroke" [size]="size" class="action_icon"></icon>
  <span><ng-content></ng-content></span>
  <icon class="icon_subList" *ngIf="subMenu" name="angle_right" stroke size="12"></icon>
</button>
`,
  styles: [`a.menu_action,button.menu_action{cursor:pointer;outline:0;border:none;font-family:roboto;position:relative;background:#fff;color:#363636;font-size:14px;justify-content:flex-start;align-items:center;width:100%;padding:0 20px;height:40px;display:flex;box-sizing:border-box;text-align:left}a.menu_action::-moz-focus-inner,button.menu_action::-moz-focus-inner{border:0}a.menu_action.hidden,button.menu_action.hidden{display:none}a.menu_action.menu_action--bordered,button.menu_action.menu_action--bordered{margin-top:11px}a.menu_action.menu_action--bordered:before,button.menu_action.menu_action--bordered:before{content:'';position:absolute;top:-6px;left:0;border-top:1px solid #cbcbcb;width:100%;height:0}a.menu_action.menu_action--icon,button.menu_action.menu_action--icon{padding:0 5px}a.menu_action span,button.menu_action span{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}a.menu_action icon,button.menu_action icon{color:#000;text-align:center;width:40px;height:15px}a.menu_action icon.icon_subList,button.menu_action icon.icon_subList{position:absolute;right:0;top:15px}a.menu_action.active,a.menu_action:focus,button.menu_action.active,button.menu_action:focus{background:#0081e3;color:#fff}a.menu_action.active icon,a.menu_action:focus icon,button.menu_action.active icon,button.menu_action:focus icon{color:#fff}a.menu_action.active .menu_list,button.menu_action.active .menu_list{visibility:visible;opacity:1}a.menu_action:active,button.menu_action:active{background:#0064b0}`],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MenuItemComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('button') private _trigger: ElementRef;
  @Input() public withBorder: boolean|any;
  @Input() public withIcon: string;
  @Input() public subMenu: MenuComponent;
  @Input() public disabled: boolean;
  @Input() public active: boolean;
  @Output() public onClick: EventEmitter<any> = new EventEmitter();
  public stroke: number;
  public iconName: string;
  public size: number;

  ngOnInit() {
    if ( Tools.isDefined(this.withIcon) ) {
      let [iconName, stroke, size] = this.withIcon.split('|');
      this.iconName = iconName;
      this.stroke = (stroke === 'stroke') ? 3 : undefined;
      this.size = (Tools.isDefined(size)) ? +size : 18;
    }
  }

  ngAfterViewInit() {
    if ( this.subMenu ) {
      this.subMenu.initSubMenu(this._trigger.nativeElement);
    }
    if ( this._trigger ) {
      this._trigger.nativeElement.addEventListener('focus', this.onFocus.bind(this));
      this._trigger.nativeElement.addEventListener('focusout', this.focusOut.bind(this));
    }
  }

  ngOnDestroy() {
    if ( this._trigger ) {
      this._trigger.nativeElement.removeEventListener('focus', this.onFocus.bind(this));
      this._trigger.nativeElement.removeEventListener('focusout', this.focusOut.bind(this));
    }
  }

  private onFocus(): void {
    if ( this.subMenu ) {
      this.subMenu.show(this._trigger.nativeElement.getBoundingClientRect());
    }
  }

  private focusOut(): void {
    if ( this.subMenu && !this._trigger.nativeElement.classList.contains('active') ) {
      this.subMenu.hide();
    }
  }

  public trigger(event: MouseEvent): void {
    if ( !this.subMenu ) {
      this.onClick.emit(event);
    } else {
      event.preventDefault();
      event.stopPropagation();
    }
  }
}
